import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, WritableSignal, computed, effect, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetUserProfileResponse } from '@core/models/DTOs/userProfile.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { NotificationService } from '@shared/components/notification/notification.service';

import { trigger, transition, style, animate } from '@angular/animations';
import { DatepickerService } from '@shared/services/datepicker.service';
import { WINDOW } from '../../app.module';
import { isPlatformBrowser } from '@angular/common';

export const fadeAnimation = trigger('fadeAnimation', [
    transition(':enter', [
        // :enter triggers when the element is added to the DOM
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })), // animate to full opacity
    ]),
    transition(':leave', [
        animate('500ms', style({ opacity: 0 })), // animate to zero opacity
    ]),
]);
@Component({
    selector: 'iho-home-page-wrapper',
    templateUrl: './home-page-wrapper.component.html',
    styleUrls: ['./home-page-wrapper.component.scss'],
})
export class HomePageWrapperComponent implements OnInit, OnDestroy {
    public route = inject(ActivatedRoute);
    notif = inject(NotificationService);
    authService = inject(AuthService);
    datepickerService = inject(DatepickerService);
    userData!: WritableSignal<GetUserProfileResponse>;
    isDatepickerOpen = computed(() => this.datepickerService._state());

    constructor(@Inject(WINDOW) private window: Window,
        @Inject(PLATFORM_ID) public platformId: Object) {
        effect(() => {
            this.userData = this.authService.getUserData();
        });
    }

    inputValue = '';
    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.window?.document?.body?.classList.add('overflow-x-hidden'); // Add class
        }
    }
    ngOnDestroy(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.window?.document?.body?.classList.remove('overflow-x-hidden'); // Remove class
        }
    }

}
